import i18next from 'i18next';

import { JobInfoViewActionButton } from 'types/jobs';

import { JOBS_INFO_VIEW_ACTION_BUTTON_SETTINGS } from 'constants/jobsSettings';

type GetJobInfoViewActionButtonsParams = {
  onReactivate: () => void;
  onRetryPayment: () => void;
  onUpdatePayment: () => void;
  onCloseJob: () => void;
};

type JobInfoViewActionButtons = {
  retryPaymentButton: JobInfoViewActionButton;
  reactivateButton: JobInfoViewActionButton;
  updatePaymentButton: JobInfoViewActionButton;
  closeJobButton: JobInfoViewActionButton;
};

export const getJobInfoViewActionButtons = ({
  onReactivate,
  onRetryPayment,
  onUpdatePayment,
  onCloseJob
}: GetJobInfoViewActionButtonsParams): JobInfoViewActionButtons => {
  const { closeJob, retryPayment, reactivate, updatePayment } =
    JOBS_INFO_VIEW_ACTION_BUTTON_SETTINGS;

  return {
    retryPaymentButton: {
      key: retryPayment.key,
      label: i18next.t(retryPayment.labelKey),
      onClick: onRetryPayment
    },
    reactivateButton: {
      key: reactivate.key,
      label: i18next.t(reactivate.labelKey),
      onClick: onReactivate
    },
    updatePaymentButton: {
      key: updatePayment.key,
      label: i18next.t(updatePayment.labelKey),
      onClick: onUpdatePayment
    },
    closeJobButton: {
      key: closeJob.key,
      label: i18next.t(closeJob.labelKey),
      onClick: onCloseJob
    }
  };
};
